import { EncuestaDTO } from "@DTOS";

export abstract class ExportadorEncuestasExcel {
    abstract exportar(encuestaDTO: EncuestaDTO): void;
}
